// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {IconRetry} from '@wandb/weave/components/Icon';
import React from 'react';

import {AccountIconLocation} from '../../../pages/Billing/AccountSettings/AccountIcon';
import {AccountSelectorAccountInfo} from './AccountSelectorAccountInfo';
import * as S from './ProfileMenu.styles';
import {type Account} from './types';

type AccountSelectorMenuItemProps = {
  account: Account | null;
  isSelectedAccount: boolean;
};

export function AccountSelectorMenuItem({
  account,
  isSelectedAccount,
}: AccountSelectorMenuItemProps): JSX.Element {
  if (account == null) {
    return <></>;
  }
  return (
    <>
      <S.ProfileMenuAccountContainer data-test={account?.name}>
        <AccountSelectorAccountInfo
          account={account}
          isSelectedAccount={isSelectedAccount}
          location={AccountIconLocation.ProfileMenu}
        />
      </S.ProfileMenuAccountContainer>
      {!isSelectedAccount && (
        <S.ProfileMenuRetryIcon>
          <IconRetry />
        </S.ProfileMenuRetryIcon>
      )}
    </>
  );
}
